import React from 'react'
import PropTypes from 'prop-types'

const CrossIcon = ({
  width,
  height,
  title,
  color,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>{title}</title>
    <path fillRule="evenodd" clipRule="evenodd" d="M15.998 1.91975L14.0782 0L8.00002 6.07821L1.92182 0L0.002065 1.91975L6.08027 7.99796L6.10352e-05 14.0782L1.91981 15.9979L8.00002 9.91771L14.0802 15.9979L16 14.0782L9.91977 7.99796L15.998 1.91975Z" fill="white" />
  </svg>
)

CrossIcon.propTypes = {
  width: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  height: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  title: PropTypes.string,
  color: PropTypes.string,
}

CrossIcon.defaultProps = {
  width: 20,
  height: 20,
  title: 'Invalid',
  color: 'currentColor',
}

export default CrossIcon
